<template>
  <layout-no-padding>
    <v-flex>
      <v-card>
        <v-container fluid>
          <v-layout row wrap class="vertical-center-container">
            <multi-batch-actions
              v-if="userAuthClass"
              :selectedCount="selectedCount"
            ></multi-batch-actions>
            <!-- <actions
              v-if="userAuthClass"
              :selectedCount="selectedCount"
              :selected="selected"
              :selectedAll="selectedAll"
              :pagination="pagination"
            ></actions> -->
            <v-spacer></v-spacer>
            <v-flex xs12 sm2 md4 class="text-xs-right">
              <v-tooltip bottom v-if="selected.length > 0 && !selectedAll">
                  <v-btn flat color="grey" icon @click="selected = []; selectedAll = false" slot="activator">
                    <v-icon>remove_circle</v-icon>
                  </v-btn>
                  <span>Deselect All</span>
                </v-tooltip>
              <v-tooltip bottom>
                <v-menu
                  slot="activator"
                  bottom
                  left
                  transition="scale-transition"
                  max-height="600px"
                  origin="top right"
                  :close-on-content-click="false"
                  v-model="fieldChooserMenu"
                >
                  <v-btn flat icon color="grey" slot="activator">
                    <v-icon>filter_list</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile v-for="header of possibleHeaders" :key="header.value">
                      <v-list-tile-action>
                        <v-checkbox
                          :color="$store.state.global.pages.allocation.color"
                          v-model="defaultHeaders"
                          :label="header.text"
                          :value="header.value"
                        ></v-checkbox>
                      </v-list-tile-action>
                    </v-list-tile>
                  </v-list>
                </v-menu>
                <span>Add & Remove Columns</span>
              </v-tooltip>
            </v-flex>

            <!-- SELECT ALL ALERT -->
            <v-alert
              v-if="selectedCount >= 10"
              :value="true"
              color="grey lighten-3"
              icon="notification_important"
              style="width: 100%; border-radius: 4px;"
              class="grey--text text--darken-2 py-1"
            >
              <div class="flex-container-center">
                <span>{{selectedCount}} items are selected.</span>
                <v-btn
                  v-if="selectedAll"
                  @click="selected = []; selectedAll = false;"
                  flat
                  color="grey"
                >Unselect all {{$vuetify.breakpoint.smAndUp ? `${selectedCount} items` : ''}}</v-btn>
                <v-btn
                  v-else
                  @click="selectedAll = true"
                  flat
                  :color="$store.state.global.pages.docket.color"
                >Select all {{$vuetify.breakpoint.smAndUp ? `${pagination.totalItems} items` : ''}}</v-btn>
              </div>
            </v-alert>
          </v-layout>
        </v-container>

        <v-data-table
          :items="batches"
          :headers="headers"
          :pagination.sync="pagination"
          :rows-per-page-items="pagination.rowsPerPageItems"
          :total-items="pagination.totalItems"
          v-model="selected"
          select-all
          :loading="loading"
          disable-initial-sort
        >
          <template slot="no-data">
            <div class="text-xs-center grey--text subheading">No batches for the selected criteria.</div>
          </template>

          <template slot="items" slot-scope="props">
            <batch-row
              :batch="props.item"
              :value="props.selected"
              :headers="headers"
              @input="toggleSelected"
              :key="props.item.id+props.item.updatedAt"
              :ref="props.item.id"
            ></batch-row>
          </template>
        </v-data-table>

        <!-- DISPLAY TOTALS -->
        <!-- DISPLAY TOTALS -->
        <v-container fluid>
          <v-layout row wrap v-if="!!batches.length" class="grey--text"></v-layout>
        </v-container>
      </v-card>
    </v-flex>
  </layout-no-padding>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import AllocationService from '@/services/requests/allocationService'
import BatchRow from './batchRow'
import Actions from './batchActions'
import MultiBatchActions from './actions/multiBatchActions'
import CalculateTotal from '@/services/mixins/calculateTotal'
import StagingViewMixin from './mixins/stagingViewMixin'
import HeaderFilters from '@/services/mixins/headerFilters'
import BuildBatchQuery from './mixins/buildBatchQuery'
import { debounce } from 'lodash'
export default {
  components: {
    BatchRow,
    Actions,
    MultiBatchActions
  },
  mixins: [HeaderFilters, StagingViewMixin, CalculateTotal, BuildBatchQuery],
  data() {
    return {
      searchTerm: '',
      loading: false,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 0,
        rowsPerPageItems: [10, 20, 40, 50]
      },
      totals: null,
      fieldChooserMenu: false
    }
  },
  methods: {
    //ADDS OR REMOVES OBJECTS FROM THE SELECTED ARRAY, DEPENDING ON WHETHER TRUE OR FALSE WAS EMMITED FROM TRIPROW COMPONENT
    toggleSelected(val) {
      if (val.value) {
        this.selected.push(val.object)
      } else {
        var index = this.selected.indexOf(val.object)
        this.selected.splice(index, 1)
      }
    },
    getBatches(keepPage) {
      if (!keepPage) this.pagination.page = 1
      //BUILD QUERY FROM MIXIN
      var payload = this.buildQuery()
      payload.pagination = this.pagination
      this.retrieveBatches(payload)
    },
    retrieveBatches(payload) {
      this.loading = true
      AllocationService.getBatches(payload)
        .then(result => {
          console.log(result)
          this.batches = result.data.result

          this.pagination.totalItems = result.data.count
          this.totals = result.data.totals
          this.loading = false
        })
        .catch(err => {
          this.snackError()
          console.log(err)
          this.loading = false
        })
    }
  },
  computed: {
    batches: Store.getSet({ store: 'allocationStaging', prop: 'batches' }),
    filterBy: Store.getSet({ store: 'allocationStaging', prop: 'filterBy' }),
    filterCol: Store.getSet({ store: 'allocationStaging', prop: 'filterCol' }),
    //dates: Store.getSet({store: 'allocationStaging', prop: 'dates'}),
    selected: Store.getSet({ store: 'allocationStaging', prop: 'selected' }),
    selectedAll: Store.getSet({
      store: 'allocationStaging',
      prop: 'selectedAll'
    }),
    selectedCount() {
      if (this.selectedAll) {
        return this.pagination.totalItems
      } else {
        return this.selected.length
      }
    },
    showClosed: Store.getSet({ store: 'shared', prop: 'showClosed' }),
    //billingPeriod: Store.getSet({store: 'shared', prop: 'billingPeriod'}),
    projectId: Store.getSet({ store: 'shared', prop: 'projectId' }),
    siteId: Store.getSet({ store: 'shared', prop: 'siteId' }),
    selectedUserId: Store.getSet({ store: 'shared', prop: 'selectedUserId' }),
    dateRangeStart: Store.getSet({ store: 'shared', prop: 'dateRangeStart' }),
    dateRangeEnd: Store.getSet({ store: 'shared', prop: 'dateRangeEnd' }),
    fetchBatches: Store.getSet({
      store: 'allocationStaging',
      prop: 'fetchBatches'
    })
  },
  mounted() {
    this.getBatches()
  },
  beforeDestroy() {
    this.batches = []
    this.selected = []
  },
  watch: {
    //TRIGGER REQUERIES OF DATA WHEN FILTERS CHANGE
    // billingPeriod(val) {
    //     this.getBatches()
    // },
    showClosed(val) {
      this.getBatches()
    },
    projectId(val) {
      this.getBatches()
    },
    siteId(val) {
      this.getBatches()
    },
    selectedUserId(val) {
      this.getBatches()
    },
    pagination(val) {
      this.getBatches(true)
      this.$store.commit('allocationStaging/setState', {
        prop: 'pagination',
        value: val
      })
    },
    filterCol: debounce(function() {
      this.getBatches()
    }, 200),
    filterBy: debounce(function() {
      this.getBatches()
    }, 500),
    dateRangeStart(val) {
      this.getBatches()
    },
    dateRangeEnd(val) {
      this.getBatches()
    },
    fetchBatches(val) {
      if (val) {
        this.fetchBatches = false
        this.getBatches(true)
      }
    }
  }
}
</script>

<style>
</style>
